// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"615":"9fd4fd7a","715":"3170aa6a"}[chunkId] + ".chunk.js";
};